import { CLICK_IDS } from '@sunflower-games/analytics-events';
import classNames from 'classnames';
import { observer } from 'mobx-react';

import { useFlag } from '../../services/launchDarkly';
import { useStores } from '../../stores/useStores';

import styles from './PlusIcon.module.scss';
import { PlusIconGc } from './PlusIconGc';
import { PlusIconSc } from './PlusIconSc';

function OldPlus({ onPress }: { onPress: (clickId: string) => (ev: React.SyntheticEvent<HTMLElement>) => void }) {
  return (
    <button
      className={styles.oldPlusContainer}
      data-testid="lobby-open-store-btn"
      onClick={onPress(CLICK_IDS.PURCHASE.HEADER_BALANCE_PLUS_SIGN)}
    >
      +
    </button>
  );
}

export const PlusIcon = observer(function PlusIcon(props: {
  onPress: (clickId: string) => (ev: React.SyntheticEvent<HTMLElement>) => void;
}) {
  const { coinTypeStore } = useStores();
  const uiRedesignBalance = useFlag('ui_redesign_balance', true);

  if (!uiRedesignBalance) {
    return <OldPlus {...props} />;
  }

  return (
    <button
      className={styles.plusContainer}
      data-testid="lobby-open-store-btn"
      onClick={props.onPress(CLICK_IDS.PURCHASE.HEADER_BALANCE_PLUS_SIGN)}
    >
      <PlusIconGc
        className={classNames({ [styles.plusIcon]: true, [styles.visible]: coinTypeStore.coinType === 'GC' })}
      />
      <PlusIconSc
        className={classNames({ [styles.plusIcon]: true, [styles.visible]: coinTypeStore.coinType === 'SC' })}
      />
    </button>
  );
});
